/**
 * The Loading component, used while resources load
 * Keep this component as similar as possible to the resource page importing it
 */
import React from "react";
import PropTypes from "prop-types";
import { Table } from "reactstrap";
import FormattedNumber from "../../FormattedNumber";

import { FILEEDITOR } from "../../FileUploadEditorForm/utils/fileEditor";
import EditorFormHelpers from "../../FileUploadEditorForm/utils/FileUploadEditorFormHelpers";
import { useFormContext, useWatch } from "react-hook-form";
import { useSelector } from "react-redux";

const OrderTab = ({ editorTypeId }, context) => {
  const language = useSelector((state) => {
    return state.i18nState.lang;
  });
  const { control, setValue } = useFormContext();
  const formData = useWatch({ control });
  const fileJsonMock = {
    ...formData,
    editorType: editorTypeId,
    border: 0,
    width: parseInt(formData.width),
    height: parseInt(formData.height),
  };

  const selectedAmount = useWatch({
    control,
    name: "amount",
  });

  return (
    <Table striped hover>
      <thead>
        <tr>
          <th style={{ minWidth: "6rem" }}>{context.t("amount")}</th>
          <th>{context.t("discount")}</th>
          <th>{context.t("netto per item")}</th>
          <th>{context.t("brutto per item")}</th>
        </tr>
      </thead>
      <tbody>
        <tr
          onClick={() => {
            setValue("amount", 1);
          }}
          className={`hv-pointer ${
            selectedAmount === 1 ? "text-bold bg-dark text-white" : ""
          }`}
        >
          <td>1 {context.t("pcs.")}</td>
          <td className="text-success"></td>
          <td>
            <FormattedNumber
              value={
                Math.round(
                  EditorFormHelpers.calculatePrice({
                    ...fileJsonMock,
                    amount: 1,
                  }).price * 100
                ) / 100
              }
              language={language}
              unit="€"
              decimals={2}
            />
          </td>
          <td>
            <FormattedNumber
              value={
                Math.round(
                  EditorFormHelpers.calculatePrice({
                    ...fileJsonMock,
                    amount: 1,
                  }).displayPrice * 100
                ) / 100
              }
              language={language}
              unit="€"
              decimals={2}
            />
          </td>
        </tr>
        {FILEEDITOR[editorTypeId]?.discounts?.map((discount, idx) => (
          <tr
            onClick={() => {
              setValue("amount", discount.amount);
            }}
            key={idx}
            className={`hv-pointer ${
              selectedAmount >= discount.amount &&
              selectedAmount <
                (FILEEDITOR[editorTypeId]?.discounts[idx + 1]?.amount || 10000)
                ? "text-bold bg-dark text-white"
                : ""
            }`}
          >
            <td>
              {discount.amount} {context.t("pcs.")}
            </td>
            <td className="text-success">
              <strong>-{discount.percentage}%</strong>
            </td>
            <td>
              <FormattedNumber
                value={
                  Math.round(
                    (EditorFormHelpers.calculatePrice({
                      ...fileJsonMock,
                      amount: discount.amount,
                    }).displayPrice -
                      EditorFormHelpers.calculatePrice({
                        ...fileJsonMock,
                        amount: discount.amount,
                      }).displayVat) *
                      100
                  ) / 100
                }
                language={language}
                unit="€"
                decimals={2}
              />
            </td>
            <td>
              <FormattedNumber
                value={
                  Math.round(
                    EditorFormHelpers.calculatePrice({
                      ...fileJsonMock,
                      amount: discount.amount,
                    }).displayPrice * 100
                  ) / 100
                }
                language={language}
                unit="€"
                decimals={2}
              />
            </td>
          </tr>
        ))}
        <tr>
          <td colspan={4} className="bg-white text-secondary">
            {context.t("Or select individual quantity in next step")}
          </td>
        </tr>
      </tbody>
    </Table>
  );
};

/**  define proptype for the 'translation' function  */
OrderTab.contextTypes = {
  t: PropTypes.func,
};
export default OrderTab;
